import { render } from "./AddPosModal.vue?vue&type=template&id=f7996e6c&ts=true"
import script from "./AddPosModal.vue?vue&type=script&lang=ts"
export * from "./AddPosModal.vue?vue&type=script&lang=ts"

import exportComponent from "/var/jenkins_home/workspace/saas-merchant-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__